import React, { Component } from 'react'
import Router from '../Router'
import Prismic from 'prismic-javascript'

import './style.css'
const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'
const MAX_PAGE_SIZE = 100

export default class App extends Component {
  state = {
    description: [],
    mainNews: [],
    pictures: [],
    vets: [],
    services: [],
  }

  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)

    const createQuery = typeName => [
      Prismic.Predicates.at('document.type', typeName),
      { pageSize: MAX_PAGE_SIZE },
    ]
    await api.query(...createQuery('fontoshir')).then(apiResult =>
      this.setState({
        mainNews:
          (apiResult.results[0] && apiResult.results[0].data.tartalom) || [],
      })
    )

    await api.query(...createQuery('rendelo-galeria')).then(apiResult => {
      this.setState({
        description: apiResult.results[0] && apiResult.results[0].data.leiras,
        pictures:
          (apiResult.results[0] &&
            apiResult.results[0].data.kepek.map(image => ({
              original: image.kep.url,
              thumbnail: image.kep.thumbnail.url,
              description: image.cim,
            }))) ||
          [],
      })
    })

    await api.query(...createQuery('allatorvos')).then(apiResult => {
      this.setState({
        vets: apiResult.results.map(vet => ({
          ...vet.data,
          id: vet.id,
        })),
      })
    })

    await api
      .query(Prismic.Predicates.at('document.type', 'szolgaltatas'), {
        pageSize: MAX_PAGE_SIZE,
        orderings: '[my.szolgaltatas.sorrend]',
      })
      .then(apiResult => {
        this.setState({
          services: apiResult.results.map(service => ({
            ...service.data,
            id: service.id,
          })),
        })
      })
  }

  render() {
    return <Router {...this.state} />
  }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js